// frontend/src/components/Requisitions/edit/constants.js

/* ✅ Ruta a la lista */
export const LIST_ROUTE = "/requisitions";

/* [LICIT] Alta de nuevas descripciones deshabilitada en UI (solo vía Django admin) */
export const SHOW_REGISTER_PRODUCT_BUTTON = false;

/* ────────────────────────────────────────────────────────────────────────────
   Step 1 catalog endpoints
──────────────────────────────────────────────────────────────────────────── */
export const CATALOG_CANDIDATES = {
  requesting_department: [
    "/catalogs/departments/",
    "/catalogs/requesting-departments/",
    "/catalogs/requesting_departments/",
  ],
  project: ["/catalogs/projects/"],
  funding_source: [
    "/catalogs/funding-sources/",
    "/catalogs/funding_sources/",
    "/catalogs/funding/",
  ],
  budget_unit: [
    "/catalogs/budget-units/",
    "/catalogs/budget_units/",
  ],
  agreement: ["/catalogs/agreements/"],
  tender: ["/catalogs/tenders/"],
  external_service: [
    "/catalogs/external-services/",
    "/catalogs/external_services/",
    "/catalogs/services/",
  ],
};

export const CATALOG_META = {
  requesting_department: { uiLabel: "Departamento Solicitante" },
  project: { uiLabel: "Proyecto" },
  funding_source: { uiLabel: "Fuente de Financiamiento" },
  budget_unit: { uiLabel: "Unidad Presupuestal" },
  agreement: { uiLabel: "Convenios" },
  tender: { uiLabel: "Licitación" },
  external_service: { uiLabel: "Servicio Externo / Académico" },
};

/* ────────────────────────────────────────────────────────────────────────────
   Step 2 (items) dynamic catalog endpoints
──────────────────────────────────────────────────────────────────────────── */
export const STEP2_SPECS = {
  productsUrlsAll: [
    "/catalogs/products/",
    "/products/",
    "/catalogs/items/",
    "/catalogs/expense-objects/",
  ],

  productsUrlsByTender: (tenderId) => [
    `/catalogs/products/?tender=${encodeURIComponent(tenderId)}`,
    `/products/?tender=${encodeURIComponent(tenderId)}`,
  ],

  unitsUrls: ["/catalogs/units/"],

  itemDescriptionsUrls: (tenderId, productId) => [
    `/catalogs/item-descriptions/?tender=${encodeURIComponent(tenderId)}&product=${encodeURIComponent(productId)}`,
    `/item-descriptions/?tender=${encodeURIComponent(tenderId)}&product=${encodeURIComponent(productId)}`,
    `/catalogs/descriptions/?tender=${encodeURIComponent(tenderId)}&product=${encodeURIComponent(productId)}`,
  ],

  itemDescriptionsByTenderUrls: (tenderId) => [
    `/catalogs/item-descriptions/?tender=${encodeURIComponent(tenderId)}`,
    `/item-descriptions/?tender=${encodeURIComponent(tenderId)}`,
    `/catalogs/descriptions/?tender=${encodeURIComponent(tenderId)}`,
  ],

  itemDescriptionsPostUrl: "/catalogs/item-descriptions/",
};

/* ───────────────────────────── Estatus helpers ───────────────────────────── */

export const STATUS_OPTIONS = [
  { value: "draft", label: "Borrador" },
  { value: "pending", label: "Pendiente" },
  { value: "approved", label: "Aprobado" },
  { value: "registered", label: "Registrado" },
  { value: "completed", label: "Completado" },
  { value: "sent", label: "Enviado a Unidad Central" },
  { value: "received", label: "Recibido por Oficina de Administración" },
  { value: "cancelled", label: "Cancelado" },
];

/*
  ✅ Opciones permitidas específicamente en edición.
  Se excluye:
  - "sent"   => para impedir envío manual desde la pantalla de edición
  - "draft"  => porque "Borrador" es un estado interno del wizard, no un cambio manual
*/
export const EDIT_STATUS_OPTIONS = STATUS_OPTIONS.filter(
  (opt) => opt.value !== "sent" && opt.value !== "draft"
);

export const STATUS_LABEL = new Map(
  STATUS_OPTIONS.map((opt) => [opt.value, opt.label])
);